// extracted by mini-css-extract-plugin
export default {"titleWrapper":"TaskModal_titleWrapper__GVeTo","elementModal":"TaskModal_elementModal__Lks4d","form":"TaskModal_form__REuiW","modalIcon":"TaskModal_modalIcon__XszqS"};